export default {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#1a54b7',
        secondary: '#b3d4fc',
        anchor: '#1b0581',
        accent: '#1994d9'
      },
      dark: {}
    }
  },
  icons: {
    iconfont: 'fa'
  }
}
